import React from "react";
import styles from "./Organizers.module.css";
import juho_h from "../assests/organizers/juho-h.jpg"
import juho_t from "../assests/organizers/juho-t.jpg"
import tri from "../assests/organizers/tri.jpg"
import fede from "../assests/organizers/fede.jpeg"
import linkedInLogo from "../assests/linkedin_logo.png";

const Organizers: React.FC = () => {
  return (
    <div id="organizers">
      <h1>The founders</h1>
      <div className={styles.people}>
        <div className={styles.profile}>
          <div className={styles.profileImg}><img style={{height:"100%", width:"100%", borderRadius:"50%"}} src={juho_h}/></div>
          <div className={styles.profileName}>Juho Helin</div>
          <a href="https://www.linkedin.com/in/juho-helin-aa39aa212/">
          <img className={styles.linkedInLogo} src={linkedInLogo} alt="LinkedIn logo" />
          </a>
        </div>
        <div className={styles.profile}>
          <div className={styles.profileImg}><img style={{height:"100%", width:"100%", borderRadius:"50%"}} src={juho_t}/></div>
          <div className={styles.profileName}>Juho Tapio</div>
          <a href="https://www.linkedin.com/in/juho-tapio-1b1b3a1b1/">
          <img className={styles.linkedInLogo} src={linkedInLogo} alt="LinkedIn logo" />
          </a>
        </div>
        <div className={styles.profile}>
          <div className={styles.profileImg}><img style={{height:"100%", width:"100%", borderRadius:"50%"}} src={tri}/></div>
          
          <div className={styles.profileName}>Tri Anh Phung</div>
          <a href="https://www.linkedin.com/in/tri-anh-phung/">
          <img className={styles.linkedInLogo} src={linkedInLogo} alt="LinkedIn logo" />
          </a>
        </div>
        <div className={styles.profile}>
          <div className={styles.profileImg}><img style={{height:"100%", width:"100%", borderRadius:"50%"}} src={fede}/></div>
          <div className={styles.profileName}>Federico Leuze</div>
          <a href="https://www.linkedin.com/in/federico-leuze-7b1b3a1b1/">
          <img className={styles.linkedInLogo} src={linkedInLogo} alt="LinkedIn logo" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Organizers;
